package com.parmartechnologies.storage.database

import com.parmartechnologies.storage.collection.DatabaseCollectionHelper
import kotlinx.serialization.KSerializer
import org.w3c.dom.Window

actual class AppDatabase {
    actual companion object {
        private const val TAG = "Js Database : IndexDB : "
        var window: Window? = null
        private var ins: AppDatabase? = null
        actual fun shared(): AppDatabase {
            if (ins != null) {
                return ins as AppDatabase
            } else {
                ins = AppDatabase()
                return ins!!
            }
        }
    }

    actual fun printLog(value: Any?) {
        console.log(TAG, value)
    }

    actual fun createDb(name: String) {
        IndexDatabase.openDB(window!!) {

        }
    }

    actual fun <T> createDoc(data: T, serializer: KSerializer<T>): String {
        val map: Map<String, Any?> = DatabaseCollectionHelper().encodeToMap(serializer, data)
        var id = ""
        if (map.containsKey("id")) {
            id = map["id"] as? String ?: ""
        }
        try {
            IndexDatabase.storeSerializable(data, serializer)
        } catch (e: Exception) {
            console.log("Data write error ${e.message}")
        }
        return id
    }

    actual fun <T> delete(name: String, serializer: KSerializer<T>, id: String) {
        IndexDatabase.delete(name, id)
    }

    actual fun <T> delete(
        name: String,
        serializer: KSerializer<T>,
        query: Map<String, Any?>
    ) {
//        IndexDatabase.delete(name, "")

    }

    actual fun <T> searchOne(
        name: String,
        serializer: KSerializer<T>,
        id: String,
        callBack: (Map<String, Any?>?) -> Unit
    ) {

    }

    actual fun <T> findOne(
        name: String,
        serializer: KSerializer<T>,
        id: String,
        callBack: (MutableList<String>) -> Unit
    ) {
    }

    actual fun <T> findOne(
        name: String,
        serializer: KSerializer<T>,
        andQuery: Map<String, Any?>,
        callBack: (MutableList<String>) -> Unit
    ) {
        IndexDatabase.loadAllSerializable(serializer,andQuery) {
            callBack(it)
        }
    }

    actual fun <T> findOne(
        name: String,
        serializer: KSerializer<T>,
        andQuery: Map<String, Any?>,
        orQuery: Map<String, Any?>,
        callBack: (MutableList<String>) -> Unit
    ) {
        IndexDatabase.loadAllSerializable(serializer,andQuery) {
            callBack(it)
        }
    }

    actual fun <T> findAll(
        name: String,
        serializer: KSerializer<T>,
        andQuery: Map<String, Any?>,
        callBack: (MutableList<String>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//
//        }
    }

    actual fun <T> findAll(
        name: String,
        serializer: KSerializer<T>,
        andQuery: Map<String, Any?>,
        orQuery: Map<String, Any?>,
        callBack: (MutableList<String>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//
//        }
    }

    actual fun <T> findAllOr(
        name: String,
        serializer: KSerializer<T>,
        orQuery: Map<String, Any?>,
        callBack: (MutableList<String>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//
//        }
    }

    actual fun <T> findOneByUserId(
        name: String,
        serializer: KSerializer<T>,
        id: String,
        callBack: (Map<String, Any?>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//
//        }
    }

    actual fun <T> findAllByBusinessId(
        id: String,
        serializer: KSerializer<T>,
        callBack: (MutableList<T>) -> Unit
    ) {

//        IndexDatabase.loadAllSerializable(id, serializer) { dataFromDb ->
//            callBack(dataFromDb as MutableList<T>)
//        }
    }

    actual fun <T> findAllByUserId(
        name: String,
        serializer: KSerializer<T>,
        id: String,
        callBack: (MutableList<String>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//            val allDataFromDb: MutableList<String> = allData?.toMutableList() ?: mutableListOf()
//            callBack(allDataFromDb)
//        }

    }

    actual fun <T> findOneByBusinessId(
        name: String,
        serializer: KSerializer<T>,
        id: String,
        callBack: (Map<String, Any?>) -> Unit
    ) {
//        IndexDatabase.read(name) { allData ->
//
//        }
    }

    actual fun <T> deleteAll(name: String, serializer: KSerializer<T>) {
//        IndexDatabase.delete(name)

    }

}